/**
 * Typed client for /admin-brain/* — backs the System Map screen.
 *
 * Serves the vendored NUREV Brain vault (the Obsidian LLM-wiki system map).
 * Admin-gated server-side; content is delivered only to authenticated admins
 * (never bundled into this SPA, which is publicly downloadable).
 */
import { client } from './client';

export interface BrainPage {
  path: string; // repo-relative, e.g. "Systems/nurev-api.md"
  title: string; // basename without .md
  folder: string; // top-level folder, '' for root
}

export interface BrainPageContent {
  path: string;
  markdown: string;
}

export async function fetchBrainTree(): Promise<BrainPage[]> {
  const r = await client.get<{ pages: BrainPage[] }>('/admin-brain/tree');
  return r.data.pages;
}

export async function fetchBrainPage(path: string): Promise<BrainPageContent> {
  const r = await client.get<BrainPageContent>('/admin-brain/page', {
    params: { path }
  });
  return r.data;
}

export interface BrainGraphNode {
  id: string; // page path
  title: string;
  folder: string;
  degree: number;
}
export interface BrainGraphLink {
  source: string;
  target: string;
}
export interface BrainGraphData {
  nodes: BrainGraphNode[];
  links: BrainGraphLink[];
}

export async function fetchBrainGraph(): Promise<BrainGraphData> {
  const r = await client.get<BrainGraphData>('/admin-brain/graph');
  return r.data;
}
